export default "__VITE_ASSET__B8hS4g2S__"